<div class="flex flex-col gap-4 text-sm">
  @if (loading) {
  <div class="flex animate-pulse flex-col gap-3">
    @for (i of [1, 2, 3, 4]; track i) {
    <div class="flex gap-3">
      <div class="h-5 w-5 rounded bg-gray-200"></div>
      <div class="h-10 flex-1 rounded bg-gray-100"></div>
    </div>
    }
  </div>
  } @else if (error) {
  <p class="rounded bg-red-50 p-3 text-red-700">{{ error }}</p>
  <div class="flex justify-end gap-2">
    <p-button label="Cerrar" [text]="true" severity="secondary" (onClick)="cancelled.emit()" />
    <p-button label="Reintentar" icon="pi pi-refresh" (onClick)="load()" />
  </div>
  } @else if (preview) {
  <p class="text-gray-600">
    Cliente del sistema: <strong class="text-gray-800">{{ preview.clientName }}</strong>. Se copian
    a SmartOLT los datos del cliente y del contrato.
  </p>
  <p class="-mt-2 text-xs text-gray-500">
    Zona, splitter, puerto del splitter y sector no se modifican: quedan como están en SmartOLT.
  </p>

  <div class="overflow-hidden rounded-lg border border-gray-200">
    @for (row of preview.rows; track row.key) {
    <label
      class="flex items-start gap-3 border-b border-gray-100 px-3 py-3 last:border-b-0"
      [class.bg-gray-50]="status(row) !== 'diff'"
      [class.cursor-pointer]="status(row) === 'diff'"
    >
      <p-checkbox
        [binary]="true"
        [disabled]="status(row) !== 'diff'"
        [ngModel]="selected.has(row.key)"
        (ngModelChange)="toggle(row, $event)"
        class="mt-0.5"
      />
      <div class="min-w-0 flex-1">
        <div class="flex items-center gap-2">
          <span class="font-semibold text-gray-800">{{ row.label }}</span>
          @switch (status(row)) { @case ('sync') {
          <span
            class="rounded-full bg-green-50 px-2 py-0.5 text-[11px] font-semibold text-green-700"
            >Sincronizado</span
          >
          } @case ('diff') {
          <span
            class="rounded-full bg-yellow-50 px-2 py-0.5 text-[11px] font-semibold text-yellow-700"
            >Diferente</span
          >
          } @case ('missing') {
          <span class="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-500"
            >Sin dato en el sistema</span
          >
          } }
        </div>
        <div class="mt-1 grid grid-cols-[max-content_1fr] gap-x-3 gap-y-0.5 text-xs">
          <span class="text-gray-400">SmartOLT</span>
          <span class="break-words text-gray-600">{{ row.current || '—' }}</span>
          @if (row.available) {
          <span class="text-gray-400">Sistema</span>
          <span class="break-words font-medium text-gray-800">{{ row.system }}</span>
          }
        </div>
        @if (row.adjusted && row.available) {
        <p class="mt-1 text-[11px] text-gray-400">
          Se adaptó para SmartOLT (sin tildes ni símbolos no admitidos). Original: {{ row.original
          }}
        </p>
        }
      </div>
    </label>
    }
  </div>

  @if (!pending.length) {
  <p class="rounded bg-green-50 p-3 text-green-700">SmartOLT ya tiene los datos del sistema.</p>
  }

  <div class="flex justify-end gap-2 border-t pt-3">
    <p-button label="Cerrar" [text]="true" severity="secondary" (onClick)="cancelled.emit()" />
    <p-button
      [label]="selected.size ? 'Sincronizar ' + selected.size + (selected.size === 1 ? ' dato' : ' datos') : 'Sincronizar'"
      icon="pi pi-sync"
      [loading]="saving"
      [disabled]="!selected.size"
      (onClick)="apply()"
    />
  </div>
  }
</div>
